const urlExpandValidity = `${process.env.REACT_APP_SHOPPING_CART_API_BASE_URL}`

export const paymentOneClick = async (data: any, token: string) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'x-api-key': process.env.REACT_APP_SHOPPING_CART_API_KEY
        },
        body: JSON.stringify(data),
    };
    const urlRequest = `${urlExpandValidity}`;
    const res = await fetch(urlRequest, requestOptions);
    const jsonResponse = await res.json();

    return { status: res.status, response: jsonResponse };
};